// extracted by mini-css-extract-plugin
export default {"main_size":"fabricVideo_main_size__mUk8N","main":"fabricVideo_main__5jciJ","video":"fabricVideo_video__62lSA","p":"fabricVideo_p__HQHXa"};